import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";
import { IllustrationIcon } from "~/components/illustration-icon";
import { LockSquareIcon } from "~/components/illustrations/lock-square";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "~/components/ui/card";
import { useAuthForgotPasswordForm } from "~/forms/auth/forgot-password";
import { cn } from "~/lib/utils";

export function ForgotPasswordForm({
	className,
	...props
}: React.ComponentPropsWithoutRef<"div">) {
	const form = useAuthForgotPasswordForm();

	return (
		<div className={cn("flex flex-col gap-6", className)} {...props}>
			<Card>
				<IllustrationIcon className="py-8">
					<LockSquareIcon className="size-8" />
				</IllustrationIcon>
				<CardHeader className="text-center">
					<CardTitle className="text-xl">
						<Trans>Forgot your password?</Trans>
					</CardTitle>
					<CardDescription>
						<Trans>
							No problem. Just let us know your email address and we will email
							you a password reset link that will allow you to choose a new one.
						</Trans>
					</CardDescription>
				</CardHeader>
				<CardContent>
					<form.AppForm>
						<form
							onSubmit={(e) => {
								e.preventDefault();
								e.stopPropagation();
								form.handleSubmit();
							}}
						>
							<div className="grid gap-6">
								<form.FormErrorMessages />
								<div className="grid gap-6">
									<form.AppField
										name="email"
										children={(field) => (
											<field.FormItem className="grid gap-2">
												<field.FormLabel>
													<Trans>Email</Trans>
												</field.FormLabel>
												<field.FormControl>
													<field.FormInput
														placeholder="podcast@azerion.com"
														type="email"
													/>
												</field.FormControl>
												<field.FormMessage />
											</field.FormItem>
										)}
									/>
									<form.FormButton>
										<Trans>Email Password Reset Link</Trans>
									</form.FormButton>
								</div>
								<div className="text-center text-sm">
									<Link
										className="underline underline-offset-4"
										to="/auth/login"
									>
										<Trans>← Back</Trans>
									</Link>
								</div>
							</div>
						</form>
					</form.AppForm>
				</CardContent>
			</Card>
			<div className="text-balance text-center text-xs text-muted-foreground [&_a]:underline [&_a]:underline-offset-4 [&_a]:hover:text-primary  ">
				<Trans>
					By clicking continue, you agree to our{" "}
					<a href="https://azerion.com">Terms of Service</a> and{" "}
					<a href="https://azerion.com">Privacy Policy</a>.
				</Trans>
			</div>
		</div>
	);
}
